import { Member } from '@tribeplatform/gql-client/types'

import { useI18n } from '../../i18n/providers/I18nProvider.js'
import {
  ActivityOverTimeBar,
  NewActivitiesPie,
  PopularsOfWeek,
  NewPostsTiny,
  PageViewsTiny,
} from '../charts/index.js'
import { MemberActivitiesScore } from '../charts/MemberActivitiesScore.js'
import { MemberScore } from '../charts/MemberScore.js'
import { PageViewsArea } from '../charts/PageViewsArea.js'
import { useTimeFrame } from '../hooks/useTimeFrame.js'
import { TimeFrame } from '../types/index.js'

interface Props {
  member: Member
  timeFrame?: TimeFrame
}

export const MemberAnalytics = ({
  member: { id: memberId, createdAt },
  timeFrame: parentTimeFrame,
}: Props) => {
  const { $t } = useI18n()
  const { timeFrame, TimeFrameSelect } = useTimeFrame({
    createdAt,
    parentTimeFrame,
  })

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-end">
        <TimeFrameSelect />
      </div>
      <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-s-4">
        <PageViewsTiny
          scope="actor"
          id={memberId}
          timeFrame={timeFrame}
          className="flex-1"
          toolTipText={$t({
            defaultMessage: 'Number of page views by this member',
            id: 'Analytics.Member.PageViewTooltip',
          })}
        />
        <NewPostsTiny
          scope="actor"
          id={memberId}
          timeFrame={timeFrame}
          className="flex-1"
        />
      </div>
      <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-s-4">
        <MemberScore
          scope="actor"
          id={memberId}
          timeFrame={timeFrame}
          className="flex-1"
        />
        <MemberActivitiesScore
          scope="actor"
          id={memberId}
          timeFrame={timeFrame}
          className="flex-1"
        />
      </div>
      <div className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-s-4">
        <NewActivitiesPie
          scope="actor"
          id={memberId}
          timeFrame={timeFrame}
          className="flex-1"
        />
      </div>
      <PageViewsArea
        scope="actor"
        id={memberId}
        timeFrame={timeFrame}
        className="flex-1"
      />
      <ActivityOverTimeBar
        scope="actor"
        id={memberId}
        timeFrame={timeFrame}
        className="flex-1"
      />
      <PopularsOfWeek scope="actor" id={memberId} timeFrame={timeFrame} />
    </div>
  )
}
